import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
    <span
      class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
      [ngClass]="variantClasses"
    >
      <ng-content></ng-content>
    </span>
  `,
    styles: []
})
export class AppBadge {
    @Input() variant: 'success' | 'warning' | 'danger' | 'info' | 'gray' | 'primary' | 'accent' | 'outline' = 'gray';

    get variantClasses() {
        switch (this.variant) {
            case 'primary':
                return 'bg-primary/10 text-primary ring-primary/20';
            case 'accent':
                return 'bg-accent/10 text-accent ring-accent/20';
            case 'outline':
                return 'bg-transparent text-foreground/75 ring-foreground/10';
            case 'success':
                return 'bg-green-50 text-green-700 ring-green-600/20 dark:bg-green-500/10 dark:text-green-400 dark:ring-green-500/20';
            case 'warning':
                return 'bg-yellow-50 text-yellow-800 ring-yellow-600/20 dark:bg-yellow-400/10 dark:text-yellow-500 dark:ring-yellow-400/20';
            case 'danger':
                return 'bg-red-50 text-red-700 ring-red-600/10 dark:bg-red-400/10 dark:text-red-400 dark:ring-red-400/20';
            case 'info':
                return 'bg-blue-50 text-blue-700 ring-blue-600/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/30';
            default:
                return 'bg-gray-50 text-gray-600 ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:ring-gray-400/20';
        }
    }
}
